import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Polygon, Popup, useMap, Circle } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

// Estilos CSS para mejorar los popups de Leaflet
const mapStyles = `
  .leaflet-popup-content-wrapper {
    background: #1e293b !important;
    border-radius: 0.5rem !important;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5) !important;
    border: 2px solid rgba(59, 130, 246, 0.5) !important;
  }
  
  .leaflet-popup-content {
    margin: 0 !important;
    color: #f1f5f9 !important;
    font-family: system-ui, -apple-system, sans-serif !important;
    font-weight: 500 !important;
  }
  
  .leaflet-popup-tip {
    background: #1e293b !important;
    border: 2px solid rgba(59, 130, 246, 0.5) !important;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3) !important;
  }
  
  .leaflet-popup-close-button {
    color: #f1f5f9 !important;
    font-size: 18px !important;
    font-weight: bold !important;
    padding: 4px 8px !important;
  }
  
  .leaflet-popup-close-button:hover {
    color: #ef4444 !important;
    background: rgba(239, 68, 68, 0.1) !important;
    border-radius: 0.25rem !important;
  }
`;

// Inyectar estilos
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.type = 'text/css';
  styleSheet.innerText = mapStyles;
  document.head.appendChild(styleSheet);
}

const SetViewOnLoad = ({ center, zoom }) => {
  const map = useMap();
  useEffect(() => {
    map.setView(center, zoom);
  }, [map, center, zoom]);
  return null;
};

const RimlandMap = () => {
  // Heartland (más tenue)
  const heartlandCoords = [
    [70, 30], [70, 100], [40, 100], [35, 60], [40, 30]
  ];

  // Rimland - Europa Occidental
  const rimlandEurope = [
    [60, -5], [60, 15], [40, 15], [40, -5]
  ];

  // Rimland - Medio Oriente
  const rimlandMiddleEast = [
    [40, 25], [40, 60], [25, 60], [25, 25]
  ];

  // Rimland - Asia del Sur
  const rimlandSouthAsia = [
    [35, 60], [35, 90], [10, 90], [10, 60]
  ];

  // Rimland - Asia Oriental
  const rimlandEastAsia = [
    [50, 100], [50, 140], [20, 140], [20, 100]
  ];

  return (
    <div style={{ height: '450px', width: '100%', borderRadius: '1rem', overflow: 'hidden', border: '2px solid rgba(59, 130, 246, 0.3)' }}>
      <MapContainer
        center={[40, 60]}
        zoom={2.5}
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom={false}
      >
        <SetViewOnLoad center={[40, 60]} zoom={2.5} />
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>'
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
        />
        
        {/* Heartland (tenue) */}
        <Polygon
          positions={heartlandCoords}
          pathOptions={{ 
            color: '#94a3b8', 
            fillColor: '#94a3b8', 
            fillOpacity: 0.15,
            weight: 2,
            dashArray: '5, 5'
          }}
        >
          <Popup>
            <div style={{ 
              padding: '1rem', 
              background: '#1e293b', 
              borderRadius: '0.5rem',
              border: '2px solid #94a3b8',
              minWidth: '200px'
            }}>
              <h3 style={{ 
                margin: 0, 
                marginBottom: '0.75rem', 
                color: '#94a3b8',
                fontSize: '1.1rem',
                fontWeight: 'bold'
              }}>
                🔴 Heartland
              </h3>
              <p style={{ 
                margin: 0, 
                fontSize: '1rem',
                color: '#f1f5f9',
                fontWeight: '500',
                lineHeight: '1.4'
              }}>
                <strong>Zona a Contener</strong>
              </p>
              <p style={{ 
                margin: '0.5rem 0 0 0', 
                fontSize: '0.9rem',
                color: '#cbd5e1',
                lineHeight: '1.4'
              }}>
                Según Spykman, debe ser contenida por el Rimland
              </p>
            </div>
          </Popup>
        </Polygon>

        {/* Rimland - Europa */}
        <Polygon
          positions={rimlandEurope}
          pathOptions={{ 
            color: '#3b82f6', 
            fillColor: '#3b82f6', 
            fillOpacity: 0.4,
            weight: 3
          }}
        >
          <Popup>
            <div style={{ 
              padding: '1rem', 
              background: '#1e293b', 
              borderRadius: '0.5rem',
              border: '2px solid #3b82f6',
              minWidth: '200px'
            }}>
              <h3 style={{ 
                margin: 0, 
                marginBottom: '0.75rem', 
                color: '#3b82f6',
                fontSize: '1.1rem',
                fontWeight: 'bold'
              }}>
                🔵 Rimland Europa
              </h3>
              <p style={{ 
                margin: 0, 
                fontSize: '1rem',
                color: '#f1f5f9',
                fontWeight: '500',
                lineHeight: '1.4'
              }}>
                <strong>Europa Occidental</strong>
              </p>
              <p style={{ 
                margin: '0.5rem 0 0 0', 
                fontSize: '0.9rem',
                color: '#cbd5e1',
                lineHeight: '1.4'
              }}>
                Alemania, Francia, Italia - OTAN, Plan Marshall
              </p>
            </div>
          </Popup>
        </Polygon>

        {/* Rimland - Medio Oriente */}
        <Polygon
          positions={rimlandMiddleEast}
          pathOptions={{ 
            color: '#eab308', 
            fillColor: '#eab308', 
            fillOpacity: 0.4,
            weight: 3
          }}
        >
          <Popup>
            <div style={{ 
              padding: '1rem', 
              background: '#1e293b', 
              borderRadius: '0.5rem',
              border: '2px solid #eab308',
              minWidth: '200px'
            }}>
              <h3 style={{ 
                margin: 0, 
                marginBottom: '0.75rem', 
                color: '#eab308',
                fontSize: '1.1rem',
                fontWeight: 'bold'
              }}>
                🟡 Rimland M. Oriente
              </h3>
              <p style={{ 
                margin: 0, 
                fontSize: '1rem',
                color: '#f1f5f9',
                fontWeight: '500',
                lineHeight: '1.4'
              }}>
                <strong>Medio Oriente</strong>
              </p>
              <p style={{ 
                margin: '0.5rem 0 0 0', 
                fontSize: '0.9rem',
                color: '#cbd5e1',
                lineHeight: '1.4'
              }}>
                Turquía, Irán, Arabia - Recursos energéticos
              </p>
            </div>
          </Popup>
        </Polygon>

        {/* Rimland - Asia del Sur */}
        <Polygon
          positions={rimlandSouthAsia}
          pathOptions={{ 
            color: '#22c55e', 
            fillColor: '#22c55e', 
            fillOpacity: 0.4,
            weight: 3
          }}
        >
          <Popup>
            <div style={{ 
              padding: '1rem', 
              background: '#1e293b', 
              borderRadius: '0.5rem',
              border: '2px solid #22c55e',
              minWidth: '200px'
            }}>
              <h3 style={{ 
                margin: 0, 
                marginBottom: '0.75rem', 
                color: '#22c55e',
                fontSize: '1.1rem',
                fontWeight: 'bold'
              }}>
                🟢 Rimland Asia Sur
              </h3>
              <p style={{ 
                margin: 0, 
                fontSize: '1rem',
                color: '#f1f5f9',
                fontWeight: '500',
                lineHeight: '1.4'
              }}>
                <strong>Asia del Sur</strong>
              </p>
              <p style={{ 
                margin: '0.5rem 0 0 0', 
                fontSize: '0.9rem',
                color: '#cbd5e1',
                lineHeight: '1.4'
              }}>
                India, Pakistán - Gran población
              </p>
            </div>
          </Popup>
        </Polygon>

        {/* Rimland - Asia Oriental */}
        <Polygon
          positions={rimlandEastAsia}
          pathOptions={{ 
            color: '#8b5cf6', 
            fillColor: '#8b5cf6', 
            fillOpacity: 0.4,
            weight: 3
          }}
        >
          <Popup>
            <div style={{ 
              padding: '1rem', 
              background: '#1e293b', 
              borderRadius: '0.5rem',
              border: '2px solid #8b5cf6',
              minWidth: '200px'
            }}>
              <h3 style={{ 
                margin: 0, 
                marginBottom: '0.75rem', 
                color: '#8b5cf6',
                fontSize: '1.1rem',
                fontWeight: 'bold'
              }}>
                🟣 Rimland Asia Oriental
              </h3>
              <p style={{ 
                margin: 0, 
                fontSize: '1rem',
                color: '#f1f5f9',
                fontWeight: '500',
                lineHeight: '1.4'
              }}>
                <strong>Asia Oriental</strong>
              </p>
              <p style={{ 
                margin: '0.5rem 0 0 0', 
                fontSize: '0.9rem',
                color: '#cbd5e1',
                lineHeight: '1.4'
              }}>
                China, Japón, Corea - Mayor densidad poblacional
              </p>
            </div>
          </Popup>
        </Polygon>

        {/* Puntos estratégicos */}
        <Circle center={[52, 13]} radius={100000} pathOptions={{ color: '#ef4444', fillColor: '#ef4444', fillOpacity: 0.6 }}>
          <Popup>
            <div style={{ 
              padding: '0.75rem', 
              background: '#1e293b', 
              borderRadius: '0.5rem',
              border: '2px solid #ef4444',
              minWidth: '150px',
              textAlign: 'center'
            }}>
              <h4 style={{ 
                margin: 0, 
                marginBottom: '0.5rem', 
                color: '#ef4444',
                fontSize: '1rem',
                fontWeight: 'bold'
              }}>
                🔴 Berlín
              </h4>
              <p style={{ 
                margin: 0, 
                fontSize: '0.9rem',
                color: '#f1f5f9',
                lineHeight: '1.3'
              }}>
                Punto focal Guerra Fría
              </p>
            </div>
          </Popup>
        </Circle>
        <Circle center={[41, 29]} radius={100000} pathOptions={{ color: '#ef4444', fillColor: '#ef4444', fillOpacity: 0.6 }}>
          <Popup>
            <div style={{ 
              padding: '0.75rem', 
              background: '#1e293b', 
              borderRadius: '0.5rem',
              border: '2px solid #ef4444',
              minWidth: '150px',
              textAlign: 'center'
            }}>
              <h4 style={{ 
                margin: 0, 
                marginBottom: '0.5rem', 
                color: '#ef4444',
                fontSize: '1rem',
                fontWeight: 'bold'
              }}>
                🔴 Estambul
              </h4>
              <p style={{ 
                margin: 0, 
                fontSize: '0.9rem',
                color: '#f1f5f9',
                lineHeight: '1.3'
              }}>
                Control de estrechos
              </p>
            </div>
          </Popup>
        </Circle>
        <Circle center={[35, 139]} radius={100000} pathOptions={{ color: '#ef4444', fillColor: '#ef4444', fillOpacity: 0.6 }}>
          <Popup>
            <div style={{ 
              padding: '0.75rem', 
              background: '#1e293b', 
              borderRadius: '0.5rem',
              border: '2px solid #ef4444',
              minWidth: '150px',
              textAlign: 'center'
            }}>
              <h4 style={{ 
                margin: 0, 
                marginBottom: '0.5rem', 
                color: '#ef4444',
                fontSize: '1rem',
                fontWeight: 'bold'
              }}>
                🔴 Tokio
              </h4>
              <p style={{ 
                margin: 0, 
                fontSize: '0.9rem',
                color: '#f1f5f9',
                lineHeight: '1.3'
              }}>
                Aliado clave en Asia
              </p>
            </div>
          </Popup>
        </Circle>
      </MapContainer>
    </div>
  );
};

export default RimlandMap;
